export default __webpack_public_path__ + "static/media/logo2.2be18944.png";